import { Row, Col, Modal, Form, Input } from "antd";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import lang from "../../helper/lang";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";

const AddForm = ({
  path,
  sectionName,
  show,
  hide,
  data,
  refresh,
  isUpdate,
}) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!data) return;

    form.setFieldsValue({
      ...data,
      name: data?.name,
    });
  }, [data]);

  const onCreate = (values) => {
    const { name } = values;

    const payload = {
      name,
    };

    setLoading(true);
    if (isUpdate) {
      request({
        url: `${apiPath.updateRole}/${data._id}`,
        method: "PUT",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setLoading(false);
        },
      });
    } else {
      request({
        url: `${apiPath.addRole}`,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setLoading(false);
        },
      });
    }
  };

  return (
    <Modal
      width={600}
      open={show}
      title={`${
        data
          ? lang("Update") + " " + sectionName
          : lang("Add") + " " + lang("New") + " " + sectionName
      }`}
      okText={`${data ? lang("Update") : lang("Add")}`}
      cancelText={
        <>
          <CloseOutlined style={{ marginRight: "8px" }} />
          {lang("Cancel")}
        </>
      }
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
        icon: <CheckOutlined />,
      }}
    >
      <Form
        id="create"
        form={form}
        initialValues={{ deal_in: "Products" }}
        onFinish={onCreate}
        layout="vertical"
      >
        <Row gutter={[16, 16]}>
          <Col span={24} lg={24}>
            <Form.Item
              className="mb-1"
              label="Enter Role"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please Enter Role",
                },
              ]}
            >
              <Input placeholder="Enter The Role" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddForm;
